/**
 * 방명록 표준 컨트롤러.
 *
 * 디자이너 DOM:
 *  - 리스트: [data-guestbook-list] 또는 #guestbookList
 *  - 작성 버튼: [data-guestbook-open] 또는 #guestbookOpenBtn/#guestbookWriteBtn
 *  - 작성 모달 overlay: #guestbookOverlay 또는 [data-guestbook-overlay]
 *  - 작성 form: [data-guestbook-form] 또는 #guestbookForm
 *
 * 카드 렌더링은 DOM API(createElement + textContent)로만 수행.
 * API: GET/POST /api/invitations/{id}/guestbook. 제출 시 password 필수.
 *
 * 참고: 이 컨트롤러는 B형 DOM([data-guestbook-form]/.guestbook-card/pagination)을
 * 전제한다. 신규 LLM-import 템플릿만 이 규약을 쓰고, 자사 1st-party 템플릿
 * (drawing 등)은 A형 DOM이라 여기서 findForm() 이 null → 방명록은 web 의
 * lib/viewerScript.ts(buildViewerScript)가 처리한다. 자세한 분담은 그 헤더 참조.
 */
export const GUESTBOOK_CONTROLLER_SCRIPT = `
<script data-fw-gb-controller>
(function () {
  var INVITATION_ID = {{ invitation.id | default: '' | json }};
  var MODE = {{ viewerMode | default: 'live' | json }};
  var API_BASE = INVITATION_ID ? '/api/invitations/' + INVITATION_ID : '';
  var PAGE_SIZE = 5;
  var page = 1;

  // 미리보기(preview/disabled) 전용 샘플 방명록 — 실제 데이터 노출 없이 디자인 확인용
  function sampleDate(daysAgo) {
    return new Date(Date.now() - daysAgo * 86400000).toISOString();
  }
  var SAMPLE_ENTRIES = [
    { name: '김민준', message: '결혼 진심으로 축하해! 두 사람 늘 행복하길 바랄게 💕', createdAt: sampleDate(7) },
    { name: '박서연', message: '두 분의 결혼을 진심으로 축하드립니다. 늘 사랑하며 사세요!', createdAt: sampleDate(3) },
    { name: '이도윤', message: '친구야 결혼 축하한다! 신혼여행 잘 다녀와~', createdAt: sampleDate(1) },
  ];

  function pick(sel, root) { return (root || document).querySelector(sel); }
  function findList() { return pick('[data-guestbook-list]') || pick('#guestbookList'); }
  function findEmpty() { return pick('#guestbookEmpty') || pick('[data-guestbook-empty]'); }
  function findPag() { return pick('#guestbookPagination') || pick('[data-guestbook-pagination]'); }
  function findForm() { return pick('[data-guestbook-form]') || pick('#guestbookForm'); }
  function findOverlay() { return pick('[data-guestbook-overlay]') || pick('#guestbookOverlay'); }
  function findOpen() { return pick('[data-guestbook-open]') || pick('#guestbookOpenBtn') || pick('#guestbookWriteBtn'); }
  function findClose() { return pick('[data-guestbook-close]') || pick('#guestbookClose') || pick('.rsvp-close', findOverlay()); }

  var toastTimer = null;
  function toast(msg) {
    var t = document.getElementById('__fwToast');
    if (!t) {
      t = document.createElement('div');
      t.id = '__fwToast';
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.85);color:#fff;padding:12px 20px;border-radius:8px;font-size:14px;z-index:9999;opacity:0;transition:opacity .2s;pointer-events:none;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.opacity = '0'; }, 1800);
  }
  function formatDate(iso) {
    try { var d = new Date(iso); return d.getFullYear() + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.' + String(d.getDate()).padStart(2, '0'); }
    catch (e) { return ''; }
  }

  function openModal() {
    var ov = findOverlay(); if (!ov) return;
    ov.classList.add('active');
    if (getComputedStyle(ov).display === 'none') ov.style.display = 'flex';
    if (window.__fwScrollLock) window.__fwScrollLock.lock({ allowScrollWithin: ov });
    else document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    var ov = findOverlay(); if (!ov) return;
    ov.classList.remove('active');
    ov.style.display = 'none';
    if (window.__fwScrollLock) window.__fwScrollLock.unlock();
    else document.body.style.overflow = '';
  }

  function makeCard(item) {
    var card = document.createElement('div'); card.className = 'guestbook-card';
    var header = document.createElement('div'); header.className = 'guestbook-card-header';
    var from = document.createElement('span'); from.className = 'guestbook-card-from'; from.textContent = item.name;
    var date = document.createElement('span'); date.className = 'guestbook-card-date'; date.textContent = formatDate(item.createdAt);
    header.appendChild(from); header.appendChild(date);
    var msg = document.createElement('div'); msg.className = 'guestbook-card-message'; msg.textContent = item.message;
    card.appendChild(header); card.appendChild(msg);
    return card;
  }

  function renderCards(items, total) {
    var list = findList(); var empty = findEmpty();
    if (!list) return;
    while (list.firstChild) list.removeChild(list.firstChild);
    if (!items || items.length === 0) {
      if (empty) empty.style.display = '';
    } else {
      if (empty) empty.style.display = 'none';
      for (var i = 0; i < items.length; i++) list.appendChild(makeCard(items[i]));
    }
    renderPagination(total);
  }
  function renderPagination(total) {
    var pag = findPag(); if (!pag) return;
    var totalPages = Math.max(1, Math.ceil((total || 0) / PAGE_SIZE));
    while (pag.firstChild) pag.removeChild(pag.firstChild);
    if (totalPages <= 1) { pag.style.display = 'none'; return; }
    pag.style.display = '';
    function makeBtn(label, attrs) {
      var b = document.createElement('button'); b.className = 'gb-page-btn'; b.textContent = label;
      if (attrs) for (var k in attrs) b.setAttribute(k, attrs[k]);
      return b;
    }
    var prev = makeBtn('\\u2039', { 'data-gb-prev': '' }); if (page === 1) prev.disabled = true;
    prev.classList.add('arrow');
    prev.addEventListener('click', function () { if (page > 1) { page--; load(); } });
    pag.appendChild(prev);
    for (var i = 1; i <= totalPages; i++) {
      var b = makeBtn(String(i), { 'data-gb-page': String(i) });
      if (i === page) b.classList.add('active');
      (function (p) { b.addEventListener('click', function () { page = p; load(); }); })(i);
      pag.appendChild(b);
    }
    var next = makeBtn('\\u203A', { 'data-gb-next': '' }); if (page === totalPages) next.disabled = true;
    next.classList.add('arrow');
    next.addEventListener('click', function () { if (page < totalPages) { page++; load(); } });
    pag.appendChild(next);
  }

  function load() {
    // 미리보기/비활성 모드: 실제 방명록 대신 샘플 렌더
    if (MODE === 'preview' || MODE === 'disabled') {
      renderCards(SAMPLE_ENTRIES, SAMPLE_ENTRIES.length);
      return;
    }
    if (!API_BASE) { renderCards([], 0); return; }
    fetch(API_BASE + '/guestbook?page=' + page + '&pageSize=' + PAGE_SIZE, { credentials: 'include' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) renderCards(d.data.entries || [], d.data.total || 0);
      })
      .catch(function () { /* silent */ });
  }

  function onSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = findForm(); if (!form) return;
    if (MODE === 'preview') { toast('미리보기입니다. 청첩장을 생성하면 실제로 저장됩니다.'); form.reset(); closeModal(); return; }
    if (MODE === 'disabled' || !API_BASE) { toast('청첩장을 먼저 생성해주세요.'); return; }
    var fd = new FormData(form);
    var name = (fd.get('name') || '').toString().trim();
    var message = (fd.get('message') || '').toString().trim();
    var password = (fd.get('password') || '').toString();
    if (!name || !message) { toast('이름과 메시지를 입력해주세요.'); return; }
    if (!password) { toast('비밀번호를 입력해주세요.'); return; }
    var btn = form.querySelector('button[type="submit"]') || form.querySelector('.rsvp-submit');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '작성 중...'; }
    fetch(API_BASE + '/guestbook', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name, message: message, password: password, isPrivate: false }),
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, status: res.status, data: d }; }); })
      .then(function (r) {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        if (r.ok && r.data.success) {
          toast('방명록이 등록되었습니다.');
          form.reset(); closeModal();
          page = 1; load();
        } else if (r.status === 429) { toast('제출 횟수를 초과했습니다.'); }
        else { toast((r.data && r.data.error && r.data.error.message) || '방명록 등록에 실패했습니다.'); }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        toast('네트워크 오류가 발생했습니다.');
      });
  }

  function init() {
    var form = findForm();
    if (form && !form.dataset.fwGbInit) {
      form.dataset.fwGbInit = '1';
      form.addEventListener('submit', onSubmit, true);
    }
    var openBtn = findOpen();
    if (openBtn && !openBtn.dataset.fwGbOpenInit) {
      openBtn.dataset.fwGbOpenInit = '1';
      openBtn.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    }
    var closeBtn = findClose();
    if (closeBtn && !closeBtn.dataset.fwGbCloseInit) {
      closeBtn.dataset.fwGbCloseInit = '1';
      closeBtn.addEventListener('click', closeModal);
    }
    var ov = findOverlay();
    if (ov && !ov.dataset.fwGbOverlayInit) {
      ov.dataset.fwGbOverlayInit = '1';
      ov.addEventListener('click', function (e) { if (e.target === ov) closeModal(); });
    }
    load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=guestbook.js.map